import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { BsaBatchDetailsWebPage } from 'commons/types/DTO/bank/bsa'
import { Request } from 'commons/utils/request'
import { CircularProgress } from 'ui/components'

import { DetailsPage } from './components'
import { useBsaBatchDetails } from './hooks'

const routeApi = getRouteApi('/_app/bsa/batch-details/$id')

export default () => {
  const search = routeApi.useSearch()
  const { id } = routeApi.useParams()

  const { isFetching, data } = useQuery<BsaBatchDetailsWebPage, Error>({
    queryFn: () => Request.post(Request.urls.bank.bsaBatchDetailsWebPage, { id: Number(id), ...search }),
    queryKey: ['batch', search],
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })

  const { startDeleting, DeleteConfirmation } = useBsaBatchDetails(data?.id)

  if (!data) {
    return <CircularProgress centered />
  }

  return (
    <>
      <DeleteConfirmation />
      {data && <DetailsPage isPending={isFetching} data={data} onDelete={startDeleting} />}
    </>
  )
}
